import { render, staticRenderFns } from "./OnlineStatistics.vue?vue&type=template&id=35651cf6&scoped=true&"
import script from "./OnlineStatistics.vue?vue&type=script&lang=ts&"
export * from "./OnlineStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./OnlineStatistics.vue?vue&type=style&index=0&id=35651cf6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35651cf6",
  null
  
)

export default component.exports